"use client";

import React from "react";
var __jsx = React.createElement;
import APP_CONFIGURATION from "@lib/app.config";
import PaymentMethodsSection from "./components/payment-methods-section";
import BusinessInformation from "./components/segmented-business-information";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { PageContainer } from "@modules/layout/components/shared/container";
import About from "./components/about";
import useCssModules from "@lib/hooks/use-css-modules";
function FooterInterbank() {
  var _cssModules$footers$f;
  const router = useMuscleRouter();
  const isMaintenance = process.env.NEXT_PUBLIC_SHOW_LANDING_MAINTENANCE === "true";
  const {
    cssModules
  } = useCssModules();
  const {
    infoContainerClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerInterbank) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  const getPadding = () => {
    if (isMaintenance || router.isMillasBenefit()) {
      return "pt-[0px]";
    }
    return !router.isHome() && !router.isLanding() ? "pt-[100px]" : "pt-[130px]";
  };
  return __jsx(PageContainer, {
    className: "pb-0 m-auto px-0 ",
    fullWidth: true
  }, __jsx("div", {
    className: "w-full gap-2 ".concat(getPadding())
  }, __jsx(About, null), __jsx("div", {
    className: infoContainerClassNames
  }, __jsx(BusinessInformation, {
    facebookURL: APP_CONFIGURATION.config.contactInformation.links.facebook,
    instagramURL: APP_CONFIGURATION.config.contactInformation.links.instagram,
    reclamationBookURL: APP_CONFIGURATION.config.contactInformation.links.reclamationBook
  }), __jsx(PaymentMethodsSection, null))));
}
export default FooterInterbank;